import AddEpaper from './AddEpaper'

export default AddEpaper
